import api from './api';

// Get user's wishlist
export const getWishlist = async () => {
  try {
    const response = await api.get('/wishlist');
    return response.data;
  } catch (error) {
    console.error('Error fetching wishlist:', error);
    throw error;
  }
};

// Add product to wishlist
// Add product to wishlist; optional `size` attaches size metadata
export const addToWishlist = async (productId, size) => {
  try {
    const payload = { productId };
    if (size) payload.size = size;
    const response = await api.post('/wishlist', payload);
    return response.data;
  } catch (error) {
    console.error('Error adding to wishlist:', error);
    throw error;
  }
};

// Remove product from wishlist
// Remove product from wishlist; optional `size` will remove specific size entry
export const removeFromWishlist = async (productId, size) => {
  try {
    const url = size ? `/wishlist/${productId}?size=${encodeURIComponent(size)}` : `/wishlist/${productId}`;
    const response = await api.delete(url);
    return response.data;
  } catch (error) {
    console.error('Error removing from wishlist:', error);
    throw error;
  }
};

// Clear entire wishlist
export const clearWishlist = async () => {
  try {
    const response = await api.delete('/wishlist');
    return response.data;
  } catch (error) {
    console.error('Error clearing wishlist:', error);
    throw error;
  }
};

// Check if product is in wishlist
// Check if product is in wishlist; optional `size` will check for that size
export const checkWishlist = async (productId, size) => {
  try {
    const url = size ? `/wishlist/check/${productId}?size=${encodeURIComponent(size)}` : `/wishlist/check/${productId}`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error checking wishlist:', error);
    throw error;
  }
};
